import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  Box,
  Fade,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay
} from "@chakra-ui/react";
import { MdError } from "react-icons/md";
import LaunchdeckCloseButton from '../../global/components/helper-components/components/LaunchdeckCloseButton';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { updateDsrTemplate } from '../actions/dsr-template-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { MdAutoDelete } from "react-icons/md";


function ConfirmDeleteDsrTemplateModal(props) {

  const { handleCloseModal, modalTransferPayload, updateDsrTemplate, updateDsrTemplateOutcome } = props || {};

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateDsrTemplateOutcome) {
      const {updateDsrTemplateStatus, sourceEvent} = updateDsrTemplateOutcome || {}; 
      if (updateDsrTemplateStatus==='success' && sourceEvent ==="delete-dsr-template") {
        setShowLoader(false);
        handleCloseModal()
      }
    }

  }, [updateDsrTemplateOutcome, handleCloseModal]);

  const handleConfirmDeleteTemplateButton = () => {
  
    const {dsrTemplateId} = modalTransferPayload || {}
    
    if (dsrTemplateId) {
      setShowLoader(true);

      updateDsrTemplate({
        sourceEvent: "delete-dsr-template",
        dsrTemplateId: dsrTemplateId,
        status: 'deleted'
      })
    }
  
  }

  
  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <Box>
              <PageLoader />
            </Box>
          </Box>
        </Box>
      )
    }

    const displayedDsrTitle = modalTransferPayload.dsrTitle ? <i>{modalTransferPayload.dsrTitle}</i> : "this template";

    if (!showLoader) {
      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>

            <Box w="100%" my="1em" color='brandDark.500'>
              <Box fontSize='0.875em'>
                Any Rooms that had been created with {displayedDsrTitle} will remain as they are, but it will no longer be available to create new ones.
              </Box>
              <Box fontSize='0.875em' mt='1em'>
                Go ahead and delete?
              </Box>
            </Box>

            <Flex w='100%' mt='2em'>
              <Flex my='0.625em' justify='flex-end' w='100%'>
                <LaunchdeckButton bg='gray.700' color='white' px='2em'  fontSize='0.9em'  w={["100%", "100%", "auto", "auto"]} onClick={() => handleConfirmDeleteTemplateButton()} label='Delete template' />
              </Flex>
            </Flex>
          </Box>
        </Flex>
      )
    }
  }

  return (
    <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} >
      <ModalOverlay className="modal-background" />
      <ModalContent rounded='0.25em' minW={['90%', '500px']} maxW='700px'>
        <ModalBody px='0em'>
          <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
            <Flex justify='space-between' align='center' w='100%' borderBottom='1px solid' borderBottomColor='gray.300'>
              {showLoader ? <Fade in={true}>
                <Flex px='1.5em' justify='flex-start' align='center'>
                <Box as={MdAutoDelete} color='brandDark.500' boxSize="1.6em" />
                <Box px='1.5em' py='0.5em' fontSize='0.9em' color='brandDark.500'>Deleting the template...</Box>
              </Flex>

              </Fade> : <React.Fragment>
              <Flex px='1em' justify='flex-start' align='center'>
                <Box as={MdError} color='brandPink.500' boxSize="1.6em" />
                <Box px='1.5em' py='0.5em' fontSize='0.9em' color='brandDark.500'>You are about to delete this template</Box>
              </Flex>

              <Box pr='1.5em'>
                <LaunchdeckCloseButton handleCloseModal={() => handleCloseModal()} />
              </Box>
              </React.Fragment>}
             
            </Flex>

            <React.Fragment>
              {displayContent()}
            </React.Fragment>

          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrTemplateOutcome: state.updateDsrTemplateOutcome.results.data,
  };
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateDsrTemplate
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteDsrTemplateModal));
